module.exports = __webpack_public_path__ + "img/IMG_9519_L_BlackMatted.974e184e.jpg";